<template>
  <div>
    <div v-if="headers.length">
      <div id="table-received" class="received-table-wrapper">
        <table class="table">
          <div v-if="loading" class="loading">
            <v-progress-linear indeterminate color="primary darken-2"></v-progress-linear>
          </div>
          <thead>
            <tr>
              <th
                v-for="header in headers"
                :key="header.value"
                :style="{ width: header.width, 'min-width': header.width, 'text-align': header.align }"
              >
                <span class="ma-3 header-text" :class="{ 'ml-0': header.value !== 'code' }">{{ header.text }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="width: 15%" class="px-2">
                <BaseSmallInput
                  maxWidth="100%"
                  placeholder="Nhập mã đơn"
                  v-model="searchParams.code_contains"
                  @change="onRefresh"
                />
              </td>
              <td style="width: 15%" class="px-2">
                <BaseSmallInput
                  maxWidth="100%"
                  placeholder="Nhập mã đơn"
                  v-model="searchParams.description_contains"
                  @change="onRefresh"
                />
              </td>
              <td style="text-align: end" class="error--text">
                <span class="ma-3">{{ totalQuantity }}</span>
              </td>
              <td v-for="item in inventories" :key="item.name_short" style="text-align: end" class="error--text">
                <span class="ma-3">{{ `${item.actualQuantity}/${item.quantity}` }}</span>
              </td>
              <td style="text-align: end" class="error--text">
                <span class="ma-3">{{ actualTotalQuantity }}</span>
              </td>
              <td style="text-align: end" class="error--text">
                <span class="ma-3">{{ remainQuantity }}</span>
              </td>
            </tr>
            <tr v-for="item in items" :key="item.code" class="inventory">
              <td
                v-for="header in headers"
                :key="header.value"
                :style="{ width: header.width, 'min-width': header.width, 'text-align': header.align }"
                :class="{ 'primary--text': header.value === 'code' }"
              >
                <span v-if="header.value === 'description'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs" class="trundle-text">{{ item[header.value] }}</div>
                    </template>
                    <span class="white--text text-justify">
                      {{ item[header.value] }}
                    </span>
                  </v-tooltip>
                </span>
                <span
                  v-else-if="item[header.value] && item[header.value].data"
                  :class="{ 'error--text': item[header.value].isLack }"
                  class="ma-3"
                >
                  {{ item[header.value].data }}
                </span>
                <span v-else-if="!item[header.value]" class="ma-3">
                  {{ '-' }}
                </span>
                <span class="ma-3" v-else>
                  {{ item[header.value] }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="data-footer">
        <v-data-footer
          items-per-page-text="Số dữ liệu mỗi trang"
          @update:options="pagination => onPaginationChange(pagination)"
          :items-per-page-options="[10, 20, 50]"
          :options="{
            page: page,
            itemsPerPage: itemsPerPage
          }"
          :pagination="{
            page: page,
            itemsPerPage,
            pageStart: (page - 1) * itemsPerPage,
            pageStop: page * itemsPerPage,
            itemsLength: totalCount
          }"
        >
        </v-data-footer>
      </div>
    </div>
    <div v-else class="loading-screen">
      <div class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <div class="mt-2">{{ 'Đang tải bảng ...' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import BaseSmallInput from '../../../components/basic/BaseSmallInput.vue'
export default {
  components: {
    BaseSmallInput
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    inventories: Array,
    actualTotalQuantity: Number,
    remainQuantity: Number,
    totalQuantity: Number,
    totalCount: Number,
    loading: Boolean
  },
  computed: {
    formatHeader() {
      if (this.headers.length) {
        // eslint-disable-next-line
        return this.headers.sort((a, b) => a.name_short.localeCompare(b.name_short))
      }
      return []
    }
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      pageStart: 0,
      pageStop: 10,
      searchParams: {
        code_contains: '',
        description_contains: ''
      },
      get
    }
  },
  methods: {
    onPaginationChange(page) {
      this.itemsPerPage = page.itemsPerPage
      this.page = page.page
      this.onRefresh()
    },
    async onRefresh() {
      this.$emit('onRefresh', {
        _start: (this.page - 1) * this.itemsPerPage,
        _limit: this.itemsPerPage,
        ...this.searchParams
      })
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  background: white;
  position: relative;
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  z-index: 2;
  width: 100%;
  height: auto;
}

.table td {
  height: 55px;
}
tr {
  border-bottom: 1px solid #ddd;
}
td {
  height: 55px;
}
th {
  height: 70px;
  background: #c0d8ff;
}
.trundle-text {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.v-data-footer {
  background: white;
}
.loading-screen {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(105, 105, 105);
  background: rgb(220, 220, 220);
  border-radius: 4px;
}
.received-table-wrapper {
  width: 100%;
  overflow-x: auto;
}
.data-footer {
  width: 100%;
  background: white;
}
</style>
